// Dynamically change the favicon to the one at the given URL
// adapted from http://stackoverflow.com/a/29465098/393274
function favicon(url) {
    removeFavicon()
    var link=document.createElement('link')
    link.type='image/x-icon'
    link.rel='icon'
    link.href=url
    document.getElementsByTagName('head')[0].appendChild(link)
}

function removeFavicon() {
    var links=document.getElementsByTagName('link')
    var head=document.getElementsByTagName('head')[0]
    for(var i=0; i<links.length; i++) {
        if(links[i].getAttribute('rel')==='icon'){
             head.removeChild(links[i])
        }
    }
}

export default favicon

favicon.__filename__ = 'components/favicon.js'
